// Per-file upload caps (bytes). Enforced server-side at presign and client-side before upload.
const TWO_MB = 2_000_000;
const TWENTY_MB = 20_000_000;
export const PLANS = {
    free: {
        label: "Get Started",
        monthlyPrice: 0,
        annualPrice: 0,
        mobileMonthlyPrice: 0,
        mobileAnnualPrice: 0,
        maxHomes: 1,
        aiActionsPerMonth: 10,
        photosEnabled: true,
        // Unlimited photos, but stored as a single compressed display image only (no archival original).
        maxPhotos: Infinity,
        maxPhotosPerItem: 1,
        storeOriginal: false,
        maxPhotoBytes: TWO_MB,
        adsEnabled: true,
        sharingEnabled: false,
    },
    plus: {
        label: "Plus",
        monthlyPrice: 5,
        annualPrice: 50,
        mobileMonthlyPrice: 6,
        mobileAnnualPrice: 60,
        maxHomes: 1,
        aiActionsPerMonth: 100,
        photosEnabled: true,
        // Unlimited photos with full-resolution archival originals retained for download.
        maxPhotos: Infinity,
        maxPhotosPerItem: 1,
        storeOriginal: true,
        maxPhotoBytes: TWENTY_MB,
        adsEnabled: false,
        sharingEnabled: true,
    },
    pro: {
        label: "Pro",
        monthlyPrice: 10,
        annualPrice: 100,
        mobileMonthlyPrice: 12,
        mobileAnnualPrice: 120,
        maxHomes: Infinity,
        aiActionsPerMonth: Infinity,
        photosEnabled: true,
        // Everything in Plus, plus multiple photos per item.
        maxPhotos: Infinity,
        maxPhotosPerItem: 12,
        storeOriginal: true,
        maxPhotoBytes: TWENTY_MB,
        adsEnabled: false,
        sharingEnabled: true,
    },
};
export function getEffectivePlan(household) {
    return household.planOverride ?? household.plan;
}
export function getPlanConfig(plan) {
    return PLANS[plan] ?? PLANS.free;
}
//# sourceMappingURL=plans.js.map